// ─── « Notifications » — how each alert reaches you (2026-10-01) ────────────
//
// Plan docs/superpowers/plans/2026-10-01-pwa-push.md, piece 4. Route
// /admin/notifications; menu entry « Notifications » just above « Paramètres ».
//
// ⚠️ A PAGE OF ITS OWN, NOT A SECTION OF PARAMÈTRES. Paramètres holds the
// studio's settings, shared by everyone; these choices belong to the
// signed-in user (« Each user keeps their own devices and choices »).
//
// The heading is in the page, not passed to AdminLayout: the layout shows its
// title on desktop only, and the owner mostly opens this on his phone.
import { useEffect } from 'react';
import { AdminLayout } from '@/components/AdminLayout';
import { NotificationPrefsPanel } from './notifications/NotificationPrefsPanel';
import { PushNotificationsCard } from '@/components/admin/PushNotificationsCard';

export default function AdminNotificationsPage() {
  useEffect(() => {
    document.title = 'Notifications — Admin Storiz';
  }, []);

  return (
    <AdminLayout>
      <div className="max-w-3xl space-y-4">
        <div>
          <h1 className="font-heading text-[24px] leading-tight text-text-primary">Notifications</h1>
          <p className="text-[13px] text-text-secondary mt-1 leading-snug">
            Choose how each alert reaches you. Every alert also lands in the bell. These choices are yours — other users keep their own.
          </p>
        </div>
        {/* Turn push on for THIS device first — the choices below only matter once it is on. */}
        <PushNotificationsCard />
        <NotificationPrefsPanel />
      </div>
    </AdminLayout>
  );
}
